import React from "react";

import { isWeb, navigate } from "../../../../helpers/utils";

import Header from "../../common/header";
import Footer from "../../common/footer";
import {
  View,
  Dimensions,
  FlatList,
  StyleSheet,
  TextInput,
  Text,
  KeyboardAvoidingView,
  TouchableOpacity,
  Platform,
} from "react-native";
import AppConfig from "../../../../config/AppConfig";
import ManaButton from "../../common/ManaButton";
import Search from "../../common/search-bar/Search";
import RoundCheckbox from "../../common/RoundCheckbox";
import appStyles from "../../../appStyles";
import EditUser from "./EditUser";

const { height: HEIGHT, width: WIDTH } = Dimensions.get("window");

export default class EnabledUsersPage extends React.Component {
  constructor(props) {
    super(props);
    this.controller = props.controller;

    this.state = {
      userList: this.controller.state.users,
      newUser: false,
      editMode: true,
    };
  }

  goBack = () => {
    navigate(this.controller, "rn:home_card");
  };

  showUserDetails = (user) => {
    this.setState((state) => ({ ...state, selectedUser: user }));
  };

  closeUserDetails = () => {
    this.setState((state) => ({
      ...state,
      selectedUser: null,
      userList: this.controller.state.users,
    }));
  };

  render() {
    const controller = this.controller;
    const userAvatar = controller.state?.picture;
    const userList = this.state.userList;
    const newUserArgs = [];
    const { selectedUser } = this.state;

    const refresh = () => {
      controller.getItemsWithStats("feed", "rn:enabled_users");
      const list = [];
      const term = this.state.filter;
      controller.state.users.forEach((u) => {
        if (
          term == null ||
          term.length == 0 ||
          u.email.toLowerCase().includes(term.toLowerCase())
        ) {
          list.push(u);
        }
      });
      this.setState({
        userList: list,
        newUser: false,
      });
    };

    const setEnabled = (item, enabled) => {
      const action = {
        action: "save",
        target: "user",
        edit_id: item.email,
        enabled: enabled,
      };
      item.enabled = enabled;
      console.log("Save User");
      controller.cardActionWithCallback(action, refresh);
    };

    const createUser = () => {
      const action = {
        action: "save",
        target: "user",
        createByGuide: true,
        email: newUserArgs[0],
        enabled: false,
      };
      console.log("Create User");
      controller.cardActionWithCallback(action, refresh);
    };

    const showNewUser = () => {
      this.setState({
        newUser: !this.state.newUser,
      });
    };

    const filterByKeyword = ({ term }) => {
      const list = [];
      if (controller.state.users) {
        controller.state.users.forEach((u) => {
          if (
            term == null ||
            term.length == 0 ||
            u.email.toLowerCase().includes(term.toLowerCase())
          ) {
            list.push(u);
          }
        });
        this.setState({ filter: term, userList: list });
      }
    };

    const renderItem = ({ item }) => (
      <TouchableOpacity
        onPress={() => this.showUserDetails(item)}
        style={[styles.item, { flex: 1, flexDirection: "column" }]}
      >
        <Text style={styles.itemText}>{item.email}</Text>
        <View
          style={[
            {
              flex: 1,
              flexDirection: "row",
              alignItems: "center",
            },
          ]}
        >
          <Text style={styles.itemText}>Active </Text>
          <RoundCheckbox
            size={20}
            checked={item.enabled == 1}
            onValueChange={(value) => setEnabled(item, value)}
          />
          <Text> Days logged: {item.days_confirmed}</Text>
        </View>
      </TouchableOpacity>
    );

    return (
      <>
        {selectedUser ? (
          <EditUser
            user={selectedUser}
            controller={this.controller}
            goBack={this.closeUserDetails}
          />
        ) : (
          <View style={appStyles.container}>
            <KeyboardAvoidingView
              style={{ height: isWeb ? HEIGHT - 50 : HEIGHT - 80 }}
              behavior="height"
            >
              <Header
                title="Select User"
                avatar={userAvatar}
                returnPage="rn:more"
                controller={controller}
              />
              <View style={styles.buttonContainer}>
                {this.state.newUser ? (
                  <View style={{ flex: 1, flexDirection: "row" }}>
                    <TextInput
                      name={"newUserEmail"}
                      autoFocus={true}
                      multiline={false}
                      placeholderTextColor="#9C9EB9"
                      placeholder="user@domain.com"
                      onChangeText={(text) => (newUserArgs[0] = text)}
                    />
                    <ManaButton
                      onPress={createUser}
                      style={styles.button}
                      styleText={styles.buttonText}
                      text={"Create"}
                    />
                  </View>
                ) : (
                  <ManaButton
                    onPress={showNewUser}
                    style={styles.button}
                    styleText={styles.buttonText}
                    text={"New User"}
                  />
                )}
              </View>

              <FlatList
                style={styles.scrollView}
                contentContainerStyle={{ paddingBottom: 100 }}
                data={userList}
                renderItem={renderItem}
                keyExtractor={(item) => item.email}
              />

              <Search
                showIcon={false}
                controller={this.controller}
                filterResults={filterByKeyword}
                placeholder="Search users"
              />
            </KeyboardAvoidingView>

            {this.controller.hasNavigation() ? null : (
              <View style={appStyles.footerOptions}>
                <Footer controller={controller} selectedPage="" />
              </View>
            )}
          </View>
        )}
      </>
    );
  }
}

const styles = StyleSheet.create({
  button: {
    width: 200,
    height: 40,
  },
  item: {
    paddingTop: 6,
    paddingBottom: 6,
    borderBottomColor: "#F5F5F5",
    borderBottomWidth: 1,
    paddingHorizontal: 8,
  },
  itemText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 25,
    letterSpacing: 0.175,
    color: "#2D3142",
    paddingLeft: 8,
  },
  buttonContainer: {
    alignItems: "center",
    backgroundColor: "#FFF",
    borderTopLeftRadius: AppConfig.BORDER_RADIUS,
    borderTopRightRadius: AppConfig.BORDER_RADIUS,
    paddingVertical: 20,
  },
  scrollView: {
    paddingHorizontal: 10,
    backgroundColor: "#FFF",
  },
});
